import { Plain } from '../../constants/colors';
import type { MotifComponent, MotifComponentProps } from '../../motif';

export const modalLightBgVars: MotifComponentProps<MotifComponent.MODAL> = {
  '--modal-background-color': 'rgba(255, 255, 255, .7)',
  '--modal-close-background-color': Plain.BLACK,
  '--modal-close-foreground-color': Plain.WHITE,
} as const;

export const modalDarkBgVars: MotifComponentProps<MotifComponent.MODAL> = {
  '--modal-background-color': 'rgba(0, 0, 0, .7)',
  '--modal-close-background-color': Plain.WHITE,
  '--modal-close-foreground-color': Plain.BLACK,
} as const;
